import Vue from 'vue'
import Router from 'vue-router'
import routesAuthorized from '@/router/routes'

const AUTH_TOKEN = localStorage.getItem(`oidc.user:${window.API_FINX_AUTH}:portal-client-2`)
const PORTAL_CLIENT = JSON.parse(AUTH_TOKEN || '{}')

const route = (path: string, view: string, name: string, meta: any) => ({
  name: name || view,
  component: (resolve: any) => import(`@/views/${view}.vue`).then(resolve),
  path,
  meta,
})

function defaultRoute() {
  let userDefaultRoute: any = { view: '', keyAuthorized: '' }
  userDefaultRoute = !!Object.keys(PORTAL_CLIENT).length && 'profile' in PORTAL_CLIENT && 'defaultPage' in PORTAL_CLIENT.profile
    ? { ...PORTAL_CLIENT.profile.defaultPage }
    : { view: '', keyAuthorized: '' }

  if (userDefaultRoute.view) {
    if (userDefaultRoute.view === 'suporte') userDefaultRoute.view = 'suporte-hospitais'
    if (userDefaultRoute.view === 'solicitacao-cirurgia') userDefaultRoute.view = 'configuracao-usuarios'

    const route = routesAuthorized.find((item: any) => item.view === userDefaultRoute.view)
    if (route) {
      if (route!.view.includes('backoffice')) route!.meta.area = route!.view.substring('backoffice-'.length).toLowerCase()
      route!.meta.isPublic = !!(route as any).isPublic
      userDefaultRoute = { ...route }
    }
  }
  return userDefaultRoute
}

function selectRouters() {
  const r = routesAuthorized.map(path => route(path.path, path.view, path.name, path.meta))
  const dRoute = defaultRoute()
  if (dRoute.name || dRoute.view) r.push(dRoute)
  return r
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: selectRouters(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return { selector: to.hash }
    }

    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const allowedRoutes: string[] = [
    'inicio',
    'cadastroMedico',
    'assinatura',
    'BackofficeContratos',
    'BackofficeContratosDetails',
    'FinanceiroUploadNotaFiscal',
    'termos-de-uso',
    'politica-de-privacidade',
    'NoDefaultRoute',
    'NoContent',
  ]

  if (AUTH_TOKEN) {
    if ((to as any).meta.isAuthorized || (PORTAL_CLIENT.profile.pageAuthorized && PORTAL_CLIENT.profile.pageAuthorized.includes((to as any).meta.keyAuthorized))) {
      next()
    } else {
      next('/inicio')
    }
  } else if (!allowedRoutes.includes((to as any).name)) {
    next('/inicio')
  } else {
    next()
  }
})

export default router
